<template>
  <AsyncPage :loader="usePartsPageLoader" :page-component="PartsPage" />
</template>

<script setup lang="ts">
import PartsPage from "./PartsPage.vue";
import { usePartsPageLoader } from "./PartsPage.loader";
import { AsyncPage } from "@saflib/vue/components";
</script>
